/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import {
	stopCaptureGraphQlErrors,
	startCaptureGraphQlErrors,
} from '@jira/platform__graphql-relay-errors/src/index.tsx';
import { TrackedGraphQLError } from '@atlassian/jira-forge-ui-errors/src/utils/graphql-error/index.tsx';

import {
	getTraceIds,
	startCapturingTraceIds,
	stopCapturingTraceIds,
} from '@atlassian/relay-traceid';

export function trackGraphQLErrors(operationName: string): {
	stopGraphQLErrorTracking: () => void;
	getGraphQLError: () => TrackedGraphQLError | undefined;
} {
	const queryId = startCaptureGraphQlErrors();
	startCapturingTraceIds(operationName);
	return {
		stopGraphQLErrorTracking: (): void => stopCapturingTraceIds(operationName),
		getGraphQLError: (): TrackedGraphQLError | undefined => getGraphQLError(queryId, operationName),
	};
}

function getGraphQLError(key: string, operationName: string): TrackedGraphQLError | undefined {
	const errors = stopCaptureGraphQlErrors(key)
		.filter((errorWrapper) => errorWrapper.meta.operationName === operationName)
		.flatMap((errorWrapper) => errorWrapper.errors);

	if (errors.length) {
		return new TrackedGraphQLError(
			`Query ${operationName} had graphql errors`,
			errors,
			getTraceIds(operationName),
		);
	}

	return undefined;
}
